import axios from 'axios'
import Api from '@/services/Api'
import store from '@/store/store'

// Menus and page access (org.frontendRoutes / org.permissions) come from
// /contacts/permission. Login.vue fetched them once and the store keeps them in
// localStorage, and the session token never expires, so a role or organisation
// given after someone's last password login never reached their browser.
// Re-read them when the portal opens, every few minutes while it is in use and
// on every organisation switch. Plain axios, not Api(): Api() sends a 401/440
// to /login, which would loop for a deactivated user.
const MIN_INTERVAL_MS = 5 * 60 * 1000
let lastRefresh = 0

export default async function refreshPermissions (force) {
  const state = store.state
  if (!state.token || !state.user || !state.user.id || !state.currentOrg) return false
  if (!force && lastRefresh && Date.now() - lastRefresh < MIN_INTERVAL_MS) return false
  lastRefresh = Date.now()
  try {
    const response = await axios.get('/contacts/permission/' + state.user.id, {
      baseURL: Api().defaults.baseURL,
      headers: { Authorization: `Bearer ${state.token}` },
      timeout: 8000
    })
    const organisations = response.data && response.data.organisations
    if (!Array.isArray(organisations) || organisations.length === 0) return false
    const currentId = state.currentOrg.orgId || (state.currentOrg.org && state.currentOrg.org.id)
    let current = organisations.find(x => x.orgId === currentId)
    if (!current) current = organisations.find(x => x.org.frontendRoutes.length > 0) || organisations[0]
    if (JSON.stringify(organisations) === JSON.stringify(state.organisations) &&
        JSON.stringify(current) === JSON.stringify(state.currentOrg)) return false
    await store.dispatch('setOrganisations', organisations)
    await store.dispatch('setCurrentOrg', current)
    await store.dispatch('setOrgToken', current.org.token)
    return true
  } catch (err) {
    console.log('Could not refresh permissions', err && err.message)
    return false
  }
}
